export default "__VITE_ASSET__33b2317f__"